import type { PatientDataWithMatchesDto } from '../api/types/timePatientTracking';
import { PATIENT_TRACKER_TAB } from './constants';
import {
  PatientTrackerTabCounts,
  PatientTrackerFilters,
  GET_PATIENT_TRACKER_V3_RECORDS,
  SET_PATIENT_TRACKER_V3_RECORDS,
  PatientTrackerActionTypes,
  GET_PATIENT_TRACKER_V3_RECORDS_FAILED,
  SET_PATIENT_TRACKER_TAB,
  GET_PATIENT_TRACKER_V3_CATEGORY_COUNTS,
  SET_PATIENT_TRACKER_V3_CATEGORY_COUNTS,
  GET_PATIENT_TRACKER_V3_RECORDS_CSV,
  GET_PATIENT_TRACKER_V3_RECORDS_CSV_FAILED,
  SET_PATIENT_TRACKER_V3_RECORDS_CSV,
  CLEAR_PATIENT_TRACKER_V3_RECORDS_CSV,
  SHOW_PATIENT_TRACKER_V3_ERROR_MESSAGE,
  SET_PATIENT_TRACKER_V3_FILTERS,
  SET_PATIENT_TRACKER_V3_PAGINATION,
} from '../api/types/patientTrackerStore';

export const creators = {
  setPatientTrackerTab(id: string, tab: PATIENT_TRACKER_TAB): PatientTrackerActionTypes {
    return {
      type: SET_PATIENT_TRACKER_TAB,
      id,
      tab: tab as PATIENT_TRACKER_TAB,
    };
  },
  getPatientTrackerRecords(id: string, siteId: string): PatientTrackerActionTypes {
    return { type: GET_PATIENT_TRACKER_V3_RECORDS, id, siteId };
  },
  setPatientTrackerRecords(id: string, patients: PatientDataWithMatchesDto[]): PatientTrackerActionTypes {
    return { type: SET_PATIENT_TRACKER_V3_RECORDS, id, patients };
  },
  getPatientTrackerRecordsFailed(id: string, error: unknown): PatientTrackerActionTypes {
    return { type: GET_PATIENT_TRACKER_V3_RECORDS_FAILED, id, error };
  },
  getPatientTrackerRecordsCsv(id: string, siteId: string): PatientTrackerActionTypes {
    return { type: GET_PATIENT_TRACKER_V3_RECORDS_CSV, id, siteId };
  },
  getPatientTrackerRecordsCsvFailed(id: string, error: unknown): PatientTrackerActionTypes {
    return { type: GET_PATIENT_TRACKER_V3_RECORDS_CSV_FAILED, id, error };
  },
  setPatientTrackerRecordsCsv(id: string, fileName: string, data: Blob): PatientTrackerActionTypes {
    return { type: SET_PATIENT_TRACKER_V3_RECORDS_CSV, id, fileName, data };
  },
  clearPatientTrackerRecordsCsv(id: string): PatientTrackerActionTypes {
    return { type: CLEAR_PATIENT_TRACKER_V3_RECORDS_CSV, id };
  },
  getPatientTrackerCategoryCounts(id: string, siteId: string): PatientTrackerActionTypes {
    return { type: GET_PATIENT_TRACKER_V3_CATEGORY_COUNTS, id, siteId };
  },
  setPatientTrackerCategoryCounts(id: string, categoryCounts: PatientTrackerTabCounts): PatientTrackerActionTypes {
    return { type: SET_PATIENT_TRACKER_V3_CATEGORY_COUNTS, id, categoryCounts };
  },
  showPatientTrackerErrorMessage(id: string, error: unknown, defaultErrorMessage: string): PatientTrackerActionTypes {
    return {
      type: SHOW_PATIENT_TRACKER_V3_ERROR_MESSAGE,
      id,
      error,
      defaultErrorMessage,
    };
  },
  setPatientTrackerFilters(id: string, filters: Partial<PatientTrackerFilters>): PatientTrackerActionTypes {
    return { type: SET_PATIENT_TRACKER_V3_FILTERS, id, filters };
  },
  setPatientTrackerPagination(
    id: string,
    numRecords: number,
    skip: number,
    totalRecords: number,
  ): PatientTrackerActionTypes {
    return {
      type: SET_PATIENT_TRACKER_V3_PAGINATION,
      id,
      numRecords,
      skip,
      totalRecords,
    };
  },
};
